<template>
  <div ref="layout" class="page-container">
    <div class="query-title">挪用计划设置</div>
    <div class="content table-query">
      <collapse-query2>
        <template slot="content">
          <div class="query-container">
            <el-form inline size="mini" label-width="100px">
              <el-row :gutter="24">
                <el-col :lg="8" :md="12">
                  <el-form-item label="营销中心">
                    <el-select v-model="conditions.saleCenterCode" clearable>
                      <el-option
                        v-for="item in saleList"
                        :key="item.SOBID"
                        :value="item.SOBID"
                        :label="item.MC_SHORT"
                      />
                    </el-select>
                    <!-- <el-select
                      v-model="conditions.saleCenterName"
                      placeholder="请选择"
                      clearable
                      @focus="openDialog($event, '营销中心')"
                    /> -->
                  </el-form-item>
                </el-col>
                <el-col :lg="8" :md="12">
                  <el-form-item label="经销商">
                    <wly-input
                      v-model="conditions.customerName"
                      input-type="customer"
                      @enter="handleEnter(...arguments, 'query')"
                      @handleSuffixClick="openDialog($event, '客户选择', 'query')"
                    />
                  </el-form-item>
                </el-col>
                <el-col :lg="8" :md="12">
                  <el-form-item label="存货分类">
                    <el-select v-model="conditions.brand" clearable filterable>
                      <el-option
                        v-for="item in selectDataOptions['A0019']"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-button size="mini" icon="el-icon-refresh-right" @click="resetQuery">重置</el-button>
              <el-button size="mini" icon="el-icon-search" type="primary" @click="queryData(1)">查询</el-button>
            </el-form>
          </div>
        </template>
      </collapse-query2>

      <div class="table-container">
        <template v-if="isAdd">
          <TableCommon
            key="add"
            title="明细信息"
            :custome-config="() => vxeShowCustom('xTable2')"
          >
            <template #button>
              <table-button name="save" tip="保存" @click="saveData" />
              <table-button name="add" tip="增加" @click="addRow" />
              <table-button name="delete" tip="删除" @click="delRow" />
            </template>
            <vxe-grid
              ref="xTable2"
              v-loading="loading"
              class="table-block"
              border
              :highlight-hover-row="true"
              resizable
              :show-overflow="true"
              height="300"
              max-height="500"
              align="center"
              size="mini"
              :checkbox-config="{ highlight: true }"
              :radio-config="{ highlight: true }"
              :empty-render="{ name: 'NotData' }"
              :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
              :edit-config="{ trigger: 'manual', mode: 'row' }"
              :columns="gridOptionsAdd.columns"
              :data="gridOptionsAdd.data"
            >
              <template #saleCenter="{ row }">
                <el-select v-model="row.saleCenterCode" filterable size="mini" clearable @change="saleCenterChange($event, row)">
                  <el-option
                    v-for="item in saleList"
                    :key="item.SOBID"
                    :value="item.SOBID"
                    :label="item.MC_SHORT"
                  />
                </el-select>
              </template>
              <template #dealer="{ row }">
                <wly-input
                  v-model="row.dealer"
                  input-type="customer"
                  @enter="handleEnter(...arguments, 'form', row)"
                  @handleSuffixClick="openDialog($event, '客户选择', 'form', row)"
                />
              </template>
              <template #brand="{ row }">
                <el-select v-model="row.brand" placeholder="请选择" filterable size="mini">
                  <el-option
                    v-for="item in selectDataOptions['A0019']"
                    :key="item.id"
                    :label="item.name"
                    :value="item.value"
                  />
                </el-select>
              </template>
              <template #originPlanAnnual="{ row }">
                <el-input
                  v-model="row.originPlanAnnual"
                  placeholder="请选择"
                  size="mini"
                  @focus="openDialog($event, '发货计划', '', row)"
                />
              </template>
              <template #kaStore="{ row }">
                <el-input
                  v-model="row.kaStore"
                  placeholder="请选择"
                  size="mini"
                  @focus="openDialog($event, 'KA卖场', '', row)"
                />
              </template>
              <template #useAnnual="{ row }">
                <el-date-picker
                  v-model="row.useAnnual"
                  type="year"
                  value-format="yyyy"
                  placeholder="选择年"
                  size="mini"
                />
              </template>
              <template #useMonth="{ row }">
                <el-select v-model="row.useMonth" size="mini">
                  <el-option v-for="item in 12" :key="item" :value="item" :label="item" />
                </el-select>
              </template>
              <template #stealingQty="{ row }">
                <el-input v-model="row.stealingQty" size="mini" placeholder="请输入" />
              </template>
            <!-- <template></template> -->
            </vxe-grid>
          </TableCommon>
        </template>

        <template v-else>
          <TableCommon
            key="edit"
            title="明细信息"
            :custome-config="() => vxeShowCustom('xTable')"
            :pagination="pagination"
            @pagination-change="handleTablePaginationChange"
          >
            <template #button>
              <table-button name="add" tip="增加" @click="addRow" />
            </template>
            <vxe-grid
              ref="xTable"
              v-loading="loading"
              class="table-block"
              border
              :highlight-hover-row="true"
              resizable
              :show-overflow="true"
              height="300"
              max-height="500"
              align="center"
              size="mini"
              :empty-render="{ name: 'NotData' }"
              :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
              :edit-config="{ trigger: 'manual', mode: 'row' }"
              :columns="gridOptions.columns"
              :data="gridOptions.data"
            />
          </TableCommon>
        </template>

      </div>
    </div>

    <el-dialog v-dialogDrag :visible.sync="showDialog" :title="dialogTitle" width="70%">
      <template v-if="showDialog">
        <org-select v-if="dialogTitle === '营销中心'" ref="dialogSelect" />
        <k-a-store-select v-if="dialogTitle === 'KA卖场'" ref="dialogSelect" />
        <client-select v-if="dialogTitle === '客户选择'" ref="dialogSelect" />
        <goods-plan
          v-if="dialogTitle === '发货计划'"
          ref="dialogSelect"
          :query="{ partner: currentRow.customerCode, zyxdy: currentRow.saleCenterCode, partnerName: currentRow.dealer, brand: currentRow.brand }"
        />
      </template>
      <div slot="footer">
        <el-button size="small" @click="showDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitHandle">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiEmbezzPlanList, apiAddEmbezPlan } from '@/api/applyForGoods/embezzlePlan'
import { apiGetOrgOrBase } from '@/api/sap/common-sap'

import ClientSelect from '@/components/dialog/ClientSelect.vue'
import OrgSelect from '../../../components/dialog/OrgSelect.vue'
import KAStoreSelect from '../../../components/dialog/KAStoreSelect.vue'
import GoodsPlan from '../../../components/dialog/GoodsPlan.vue'
import { frontExport } from '@/utils/frontExport'
export default {
  components: {
    ClientSelect,
    OrgSelect,
    KAStoreSelect,
    GoodsPlan
  },

  data() {
    return {
      selectDataOptions: {},
      showDialog: false,
      dialogTitle: '',
      clientType: '',
      currentRow: {},
      conditions: {
        saleCenterCode: '',
        saleCenterName: '',
        customerCode: '',
        customerName: '',
        brand: ''
      },
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      isAdd: false,
      saleList: [],
      gridOptions: {
        columns: [
          { type: 'seq', title: '序号', filed: 'seq', width: 50 },
          { field: 'saleCenter', title: '营销中心', width: 120 },
          { field: 'dealer', title: '经销商', width: 120 },
          { field: 'brandTextView', title: '品牌', width: 120 },
          { field: 'kaStore', title: '卖场', width: 120 },
          { field: 'originPlanAnnual', title: '挪用年度', width: 120 },
          { field: 'originPlanMonth', title: '挪用月份', width: 120 },
          { field: 'originPlanQty', title: '当月计划量', width: 120 },
          { field: 'useAnnual', title: '使用年度', width: 120 },
          { field: 'useMonth', title: '使用月份', width: 120 },
          { field: 'stealingQty', title: '挪用量', width: 120 },
          { field: 'actUseQty', title: '使用量', width: 120 },
          { field: 'createdDate', title: '设置时间', width: 120 }
        ],
        data: []
      },
      gridOptionsAdd: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkebox', width: 50 },
          { field: 'saleCenter', title: '营销中心', width: 180, slots: { default: 'saleCenter' }},
          { field: 'dealer', title: '经销商', width: 180, slots: { default: 'dealer' }},
          { field: 'brand', title: '存货分类', width: 180, slots: { default: 'brand' }},
          { field: 'kaStore', title: '卖场', width: 180, slots: { default: 'kaStore' }},
          {
            field: 'originPlanAnnual',
            title: '挪用年度',
            width: 180,
            slots: { default: 'originPlanAnnual' }
          },
          { field: 'originPlanMonth', title: '挪用月份', width: 120 },
          { field: 'originPlanQty', title: '当月计划量', width: 120 },
          { field: 'useAnnual', title: '使用年度', width: 120, slots: { default: 'useAnnual' }},
          { field: 'useMonth', title: '使用月份', width: 120, slots: { default: 'useMonth' }},
          { field: 'stealingQty', title: '挪用量', width: 120, slots: { default: 'stealingQty' }}
        ],
        data: []
      }
    }
  },
  created() {
    // A0019
    this.getSelectDictDataOrigin('A0019')
    apiGetOrgOrBase().then(res => {
      this.saleList = res.DATA
    })
  },
  methods: {
    // 查询
    async queryData(page) {
      if (this.isAdd) {
        this.isAdd = false
        this.gridOptionsAdd.data = []
      }
      page && (this.pagination.page = page)
      // this.pagination.totalCount = 100
      this.loading = true
      const params = {
        ...this.conditions,
        ...this.pagination
      }
      try {
        const {
          data: { Rows, Total }
        } = await apiEmbezzPlanList(params)
        this.pagination.totalCount = Total
        this.gridOptions.data = Rows
        console.log(this.gridOptions.data)
      } catch (e) {
        //
      }
      this.loading = false
    },
    openDialog(e, title, type, row) {
      e.target.blur()
      this.dialogTitle = title
      type && (this.clientType = type)
      row && (this.currentRow = row)
      this.showDialog = true
    },
    addRow() {
      if (!this.isAdd) {
        this.isAdd = true
      }
      const row = {}
      this.gridOptionsAdd.columns
        .filter(v => !v.type)
        .map(v => v.field)
        .forEach(key => {
          row[key] = ''
        })
      this.gridOptionsAdd.data.unshift(row)
    },
    saleCenterChange(e, row) {
      this.currentRow = row
      this.currentRow.saleCenter = this.saleList.find(item => item.SOBID === e).MC_SHORT
    },
    // 控件回车
    async handleEnter(e, type, data, queryType, row) {
      // console.log('handleEnter', type, data)
      if (typeof type === 'object') {
        this.errorList ? (this.errorList = [type.message]) : this.$message.error(type.message)
        return
      }
      if (!data) return

      if (queryType === 'query') {
        this.conditions.customerCode = data.partner
        this.conditions.customerName = data.name_org1
      } else {
        this.currentRow = row
        this.currentRow.dealer = data.name_org1
        this.currentRow.customerCode = data.partner
      }
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()
      if (!data) return
      switch (this.dialogTitle) {
        case '客户选择':
          if (this.clientType === 'query') {
            this.conditions.customerCode = data.partner
            this.conditions.customerName = data.name_org1
          } else {
            this.currentRow.dealer = data.name_org1
            this.currentRow.customerCode = data.partner
          }
          break
        case '营销中心':
          if (this.clientType === 'query') {
            this.conditions.saleCenterName = data.name
            this.conditions.saleCenterCode = data.code
          } else {
            this.currentRow.saleCenter = data.name
            this.currentRow.saleCenterCode = data.code
          }
          break
        case 'KA卖场':
          this.currentRow.kaStore = data.fullName
          break
        case '发货计划':
          this.currentRow.originPlanQty = data.planQty
          this.currentRow.originPlanMonth = data.month
          this.currentRow.originPlanAnnual = data.pYear
          // this.currentRow.stealingPlanId = data.id
          break
      }
      this.showDialog = false
    },
    delRow() {
      const data = this.$refs.xTable2.getCheckboxRecords()
      if (data) {
        data.forEach(row => {
          const index = this.gridOptionsAdd.data.findIndex(v => v._X_ID === row._X_ID)
          this.gridOptionsAdd.data.splice(index, 1)
        })
      }
    },
    async saveData() {
      const params = this.gridOptionsAdd.data
      const { status } = await apiAddEmbezPlan(params)
      if (status === 1) {
        this.$message.success('保存成功!')
        this.queryData()
      }
    },
    resetQuery() {
      this.conditions = {
        saleCenterCode: '',
        saleCenterName: '',
        customerCode: '',
        customerName: '',
        brand: ''
      }
    },
    async exportExcel(type) {
      if (type === 'page') {
        frontExport(this.gridOptions.columns, this.gridOptions.data, '挪用计划表格')
      }
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    handleTablePaginationChange(page) {
      Object.assign(this.pagination, page)
      this.queryData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/embezzlePlan.vue